/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { Resource } from './resource';

export type GenericApiResponseResourceData = Resource | null;
